import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FlipMove from 'react-flip-move';
import Bingo from 'modules/Bingo';
import Modals from 'modules/Modals';
import { easing } from 'lib/constants';
import { CLASS_NAME_IGNORE_CLICK_OUTSIDE } from 'components/ClickOutside';
import SpriteIcon from './SpriteIcon';
import './liveBalls.css';

const HOVER_DELAY = 500;
const { GAME_TYPE } = Bingo.constants;

export class _LiveBalls extends Component {
  componentDidUpdate(prevProps) {
    const { dropped, closeCalledBalls } = this.props;

    if (dropped?.length <= 0 && prevProps.dropped?.length > 0) {
      closeCalledBalls();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.showBallsTimeout);
    this.props.closeCalledBalls();
  }

  startShowCalledBalls = () => {
    this.showBallsTimeout = setTimeout(this.props.showCalledBalls, HOVER_DELAY);
  };

  cancelShowCalledBalls = () => {
    clearTimeout(this.showBallsTimeout);
  };

  render() {
    const {
      dropped,
      numberBallsToShow,
      toggler,
      showCalledBalls,
      type,
      pictureNumbersImageUrl,
      animatedNumbersImageUrls
    } = this.props;
    const last = dropped.length - 1;
    const balls = dropped
      .slice(-numberBallsToShow)
      .reverse()
      .map((number, i) => {
        const cycledBallNumber =
          Math.abs(numberBallsToShow - (i - (last % numberBallsToShow))) % numberBallsToShow;
        if (i === 0) {
          return type === GAME_TYPE['30'] ? (
            <img
              className="spriteIcon"
              src={animatedNumbersImageUrls[number - 1]}
              alt={number}
              data-chromatic="ignore"
            />
          ) : (
            <span className={`ball latestBall added ball${cycledBallNumber}`} key={number}>
              {number}
            </span>
          );
        } else {
          return type === Bingo.constants.GAME_TYPE['30'] && pictureNumbersImageUrl ? (
            <SpriteIcon active value={number} key={number} src={pictureNumbersImageUrl} />
          ) : (
            <span className={`ball slide ball${cycledBallNumber}`} key={number}>
              {number}
            </span>
          );
        }
      });
    return (
      <div
        className={`liveBalls ${toggler}`}
        onClick={showCalledBalls}
        onMouseEnter={this.startShowCalledBalls}
        onMouseLeave={this.cancelShowCalledBalls}
      >
        <div className="nextBall">{balls[0]}</div>
        {balls.length > 1 && (
          <FlipMove
            delay={0}
            duration={450}
            easing={easing}
            staggerDurationBy={0}
            className="prevBalls"
            leaveAnimation={false}
            enterAnimation
          >
            <span>{balls.slice(-(balls.length - 1))}</span>
          </FlipMove>
        )}
      </div>
    );
  }
}

_LiveBalls.propTypes = {
  type: PropTypes.oneOf(['30', '75', '90', '']),
  dropped: PropTypes.arrayOf(PropTypes.number),
  numberBallsToShow: PropTypes.number,
  toggler: PropTypes.string,
  closeCalledBalls: PropTypes.func.isRequired,
  showCalledBalls: PropTypes.func.isRequired,
  animatedNumbersImageUrls: PropTypes.arrayOf(PropTypes.string),
  pictureNumbersImageUrl: PropTypes.string
};

_LiveBalls.defaultProps = {
  type: '',
  dropped: [],
  numberBallsToShow: 5,
  toggler: '',
  animatedNumbersImageUrls: [],
  pictureNumbersImageUrl: ''
};

const mapStateToProps = (state, { refName }) => ({
  toggler: Modals.selectors.getModal(state, 'calledBalls')?.visible
    ? CLASS_NAME_IGNORE_CLICK_OUTSIDE
    : '',
  type: Bingo.selectors.getGameType(state, refName),
  pictureNumbersImageUrl: Bingo.selectors.getPictureNumbersImageCfUrl(state, refName, 'current'),
  animatedNumbersImageUrls: Bingo.selectors.getAnimatedNumbersImageUrls(state, refName, 'current'),
  dropped: Bingo.selectors.getDropped(state, null, 'current')
});

const mapDispatchToProps = (dispatch) => ({
  showCalledBalls: () => dispatch(Modals.actions.open('calledBalls')),
  closeCalledBalls: () => dispatch(Modals.actions.close('calledBalls'))
});

const LiveBalls = connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
  _LiveBalls
);

LiveBalls.propTypes = {
  numberBallsToShow: PropTypes.number
};

export default LiveBalls;
